import React, { useEffect, useState } from "react";
import { message, Spin, Button } from "antd";
import styles from "./BusinessChart.less";
import BaseChart from "../baseChart/BaseChart.tsx";
import { ReloadOutlined } from "@ant-design/icons";
import HttpTool from "../../../../tool/HttpTool";
import APILXD from "../../../../http/APILXD";

type Props = {
  pageParams: any;
  loading?: boolean;
}

export default function(props:Props) {
  const [loading, setLoading] = useState(props.loading || false);
  const [chartConfig, setChartConfig] = useState({
    xAxis: {
      name: "",
      type: 'category',
      nameLocation: "center",
      nameGap: 25,
    },
    yAxis: {
      type: 'value',
      minInterval: 1,
      axisLabel: {
        formatter: `{value}台`
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
    },
    legend: {show: false}
  });

  useEffect(() => {
    getData();
  }, [props.pageParams]);

  const getData= ()=>{

    setLoading(true)

    HttpTool.post(APILXD.businessCountryStatistics, (code: any, msg: any, data: any) => {
      setChartConfig((oldConfig)=>{
        let newConfig = {...oldConfig}
        newConfig.dataset = {
          dimensions: ["countryName", "deviceCount"],
          source: data.sort((a,b) => b.deviceCount - a.deviceCount),
        }
        newConfig.series = [
          {
            type: "bar",
            name: "个数",
          },
        ];
        return newConfig;
      })

      setLoading(false)
    }, (code: any, msg: any) => {
      message.error(msg);
      setLoading(false)
    },  {
      ...props.pageParams
    });
  }

  return <Spin wrapperClassName={styles.spinBoxStyle} spinning={loading}>
    <div className={styles.itemBox}>
      <div className={styles.title}>
        <Button
          type={'link'}
          icon={<ReloadOutlined />}
          onClick={() => {
            getData();
          }}
        />
        国家统计
      </div>
      <BaseChart
        chartType={"bar"}
        chartConfig={chartConfig}
      />
    </div>
  </Spin>;
}
